(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('site-story')) {
    customElements.define('site-story', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (!this.isConnected || this.controller) return;
        this.scenes = Array.from(this.querySelectorAll('[data-story-scene]'));
        if (!this.scenes.length) return;
        this.stage = this.querySelector('.site-story__stage');
        this.probe = this.querySelector('.site-story__measure');
        this.header = document.querySelector('.tm-custom-header');
        this.copies = this.scenes.map(scene => scene.querySelector('.site-story__copy'));
        this.contents = this.scenes.map(scene => scene.querySelector('.site-story__content'));
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.frame = null;
        this.editorIndex = null;
        this.activeStates = new Map();
        this.needsMeasure = true;
        this.schedule = () => {
          if (this.frame !== null) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            if (this.needsMeasure) this.measure();
            this.render();
          });
        };
        this.scheduleMeasure = () => {
          this.needsMeasure = true;
          this.schedule();
        };

        window.addEventListener('scroll', this.schedule, { passive: true, signal });
        window.addEventListener('resize', this.scheduleMeasure, { passive: true, signal });
        window.addEventListener('pageshow', this.scheduleMeasure, { signal });
        this.reducedMotion.addEventListener('change', this.scheduleMeasure, { signal });
        this.mobile.addEventListener('change', this.scheduleMeasure, { signal });
        this.addEventListener('shopify:block:select', event => {
          const index = this.scenes.findIndex(scene => scene.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editorIndex = index;
          this.goToScene(index);
        }, { signal });
        this.addEventListener('shopify:block:deselect', () => {
          this.editorIndex = null;
          this.schedule();
        }, { signal });
        this.addEventListener('focusin', event => {
          const scene = event.target.closest('[data-story-scene]');
          const index = this.scenes.indexOf(scene);
          if (this.enhanced && index >= 0) {
            this.stage.scrollTop = 0;
            this.stage.scrollLeft = 0;
            const bounds = event.target.getBoundingClientRect();
            const copyStyle = getComputedStyle(this.copies[index]);
            const top = parseFloat(copyStyle.paddingTop);
            const bottom = this.viewHeight - parseFloat(copyStyle.paddingBottom);
            if (!scene.classList.contains('is-current') || bounds.top < top || bounds.bottom > bottom) {
              this.goToScene(index, event.target);
            }
          }
        }, { signal });

        this.observer = new ResizeObserver(this.scheduleMeasure);
        this.observer.observe(this.probe);
        this.contents.forEach(content => this.observer.observe(content));
        if (this.header) this.observer.observe(this.header);
        if (document.fonts) {
          document.fonts.ready.then(() => {
            if (!signal.aborted) this.scheduleMeasure();
          });
        }
        this.measure();
        this.render();
      }

      measure() {
        this.needsMeasure = false;
        this.viewHeight = this.probe.getBoundingClientRect().height;
        const headerHeight = this.header ? this.header.getBoundingClientRect().height : 80;
        const safeTop = Math.max(80, headerHeight + 40);
        this.style.setProperty('--story-safe-top', `${safeTop}px`);
        this.movement = Math.min(80, this.viewHeight * 0.1);
        this.textTravel = this.contents.map((content, index) => {
          const copyStyle = getComputedStyle(this.copies[index]);
          const padding = parseFloat(copyStyle.paddingTop) + parseFloat(copyStyle.paddingBottom);
          return Math.max(0, content.getBoundingClientRect().height + padding - this.viewHeight);
        });
        this.enhanced = this.scenes.length > 1 && this.viewHeight > 0 && !this.reducedMotion.matches &&
          !(this.mobile.matches && this.dataset.mobileMode === 'stacked');
        this.step = this.viewHeight * (Number(this.dataset.pace) || 100) / 100;
        let start = 0;
        this.sceneStarts = this.textTravel.map(distance => {
          const offset = start;
          start += this.step + distance;
          return offset;
        });
        this.travel = start - this.step * 0.5;
        this.classList.toggle('is-enhanced', this.enhanced);
        if (this.enhanced) {
          this.style.height = `${this.viewHeight + this.travel}px`;
        } else {
          this.style.removeProperty('height');
        }
      }

      clamp(value) { return Math.max(0, Math.min(1, value)); }

      ease(value) {
        const x = this.clamp(value);
        return x * x * (3 - 2 * x);
      }

      render() {
        if (!this.enhanced) return;
        const rect = this.getBoundingClientRect();
        const progress = Math.max(0, Math.min(this.travel, -rect.top));
        let current = 0;
        while (current < this.scenes.length - 1 && progress >= this.sceneStarts[current + 1]) {
          current += 1;
        }
        if (this.editorIndex !== null) current = this.editorIndex;
        const sceneProgress = Math.max(0, progress - this.sceneStarts[current]);
        const textDistance = this.textTravel[current];
        const textScrolled = Math.max(0, Math.min(textDistance, sceneProgress - this.step * 0.3));
        const textY = textDistance / 2 - textScrolled;
        const next = Math.min(this.scenes.length - 1, current + 1);
        const transitionStart = 0.05;
        const transitionDuration = 1 - transitionStart;

        const transition = this.editorIndex === null && next !== current
        ? this.clamp((sceneProgress - textDistance - this.step * transitionStart) / (this.step * transitionDuration))
        : 0;
        const outgoing = Math.sqrt(1 - this.ease(transition * 2));
        const incoming = Math.sqrt(this.ease((transition - 0.5) * 2));
        const sameImage = this.scenes[current].dataset.visualKey === this.scenes[next].dataset.visualKey;
        const currentImage = sameImage ? 1 : outgoing;
        const nextImage = sameImage ? 0 : incoming;
        const states = new Map();
        states.set(current, [currentImage, outgoing, textY - this.movement * transition]);
        if (next !== current) {
          states.set(next, [nextImage, incoming, this.textTravel[next] / 2 + this.movement * (1 - transition)]);
        }
        const active = transition >= 0.5 ? next : current;

        this.scenes.forEach((scene, index) => {
          const state = states.get(index) || [0, 0, 0];
          const previous = this.activeStates.get(index);
          if (!previous || state.some((value, position) => value !== previous[position])) {
            scene.style.setProperty('--story-image-opacity', state[0].toFixed(4));
            scene.style.setProperty('--story-copy-opacity', state[1].toFixed(4));
            scene.style.setProperty('--story-copy-y', `${state[2].toFixed(2)}px`);
            this.activeStates.set(index, state);
          }
          scene.classList.toggle('is-current', index === active);
        });
      }

      goToScene(index, target = null) {
        if (this.needsMeasure) this.measure();
        if (!this.enhanced) {
          this.scenes[index].scrollIntoView({ block: 'center', behavior: 'instant' });
          return;
        }
        let offset = this.sceneStarts[index];
        if (target && this.textTravel[index] > 0) {
          const contentBounds = this.contents[index].getBoundingClientRect();
          const targetBounds = target.getBoundingClientRect();
          const visibleHeight = contentBounds.height - this.textTravel[index];
          const targetMiddle = (targetBounds.top + targetBounds.bottom) / 2 - contentBounds.top;
          const textScrolled = Math.max(0, Math.min(this.textTravel[index], targetMiddle - visibleHeight / 2));
          offset += this.step * 0.3 + textScrolled;
        }
        const top = window.scrollY + this.getBoundingClientRect().top + offset;
        window.scrollTo({ top, behavior: 'instant' });
        this.render();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        if (this.frame !== null && this.frame !== undefined) cancelAnimationFrame(this.frame);
        if (this.controller) this.controller.abort();
        if (this.observer) this.observer.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tm-gallery')) {
    customElements.define('tm-gallery', class TMGallery extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.dialog = this.querySelector('[data-gallery-dialog]');

        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

        this.controller = new AbortController();

        const options = {
          signal: this.controller.signal
        };

        this.items = Array.from(
          this.querySelectorAll('[data-gallery-open]')
        );

        this.image = this.querySelector('[data-gallery-enlarged]');
        this.viewerTitle = this.querySelector('[data-gallery-title]');
        this.meta = this.querySelector('[data-gallery-meta]');
        this.counter = this.querySelector('[data-gallery-counter]');
        this.status = this.querySelector('[data-gallery-status]');

        this.querySelector('[data-gallery-navigation]').hidden =
          this.items.length < 2;

        this.items.forEach((item) => {
          item.setAttribute('aria-haspopup', 'dialog');
          item.setAttribute('aria-controls', `${this.id}-viewer`);
        });

        this.dialog.id = `${this.id}-viewer`;

        this.addEventListener('click', (event) => {
          const opener = event.target.closest('[data-gallery-open]');

          if (
            !opener ||
            !this.contains(opener) ||
            event.ctrlKey ||
            event.metaKey ||
            event.shiftKey ||
            event.altKey
          ) return;

          event.preventDefault();

          this.opener = opener;
          this.showImage(this.items.indexOf(opener));

          if (!this.dialog.open) {
            this.dialog.showModal();

            this.previousOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            this.scrollLocked = true;
          }

          this.querySelector('[data-gallery-close]').focus({
            preventScroll: true
          });
        }, options);

        this.querySelector('[data-gallery-close]').addEventListener(
          'click',
          () => this.dialog.close(),
          options
        );

        this.querySelector('[data-gallery-previous]').addEventListener(
          'click',
          () => this.showImage(this.index - 1),
          options
        );

        this.querySelector('[data-gallery-next]').addEventListener(
          'click',
          () => this.showImage(this.index + 1),
          options
        );

        this.dialog.addEventListener('keydown', (event) => {
          if (
            event.key === 'ArrowLeft' ||
            event.key === 'ArrowRight'
          ) {
            event.preventDefault();

            this.showImage(
              this.index + (event.key === 'ArrowRight' ? 1 : -1)
            );
          }
        }, options);

        this.dialog.addEventListener('click', (event) => {
          if (
            event.target === this.dialog ||
            event.target === this.querySelector('[data-gallery-stage]')
          ) {
            this.dialog.close();
          }
        }, options);

        this.dialog.addEventListener('close', () => {
          this.restoreScroll();

          if (this.opener && this.opener.isConnected) {
            this.opener.focus({
              preventScroll: true
            });
          }

          this.image.removeAttribute('src');
          this.status.hidden = true;
        }, options);

        this.image.addEventListener('load', () => {
          this.status.hidden = true;
        }, options);

        this.image.addEventListener('error', () => {
          if (
            !this.dialog.open ||
            !this.image.hasAttribute('src')
          ) return;

          this.image.hidden = true;
          this.status.textContent =
            'This image could not be loaded. Please close and try again.';
          this.status.hidden = false;
        }, options);
      }

      showImage(index) {
        if (!this.items.length) return;

        this.index =
          (index + this.items.length) % this.items.length;

        const item = this.items[this.index];

        this.viewerTitle.textContent = item.dataset.title;

        this.meta.textContent = [
          item.dataset.label,
          item.dataset.year
        ].filter(Boolean).join(' · ');

        this.meta.hidden = !this.meta.textContent;

        this.counter.textContent =
          `${this.index + 1} / ${this.items.length}`;

        this.status.textContent = 'Loading image…';
        this.status.hidden = false;

        this.image.hidden = false;
        this.image.alt = item.dataset.alt;
        this.image.src = item.href;

        if (
          this.image.complete &&
          this.image.naturalWidth > 0
        ) {
          this.status.hidden = true;
        }
      }

      restoreScroll() {
        if (!this.scrollLocked) return;

        document.body.style.overflow = this.previousOverflow;
        this.scrollLocked = false;
      }

      disconnectedCallback() {
        if (this.dialog && this.dialog.open) {
          this.dialog.close();
        }

        this.restoreScroll();

        if (this.controller) {
          this.controller.abort();
        }

        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
